/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum PeriodTypeEnum {
    D = 'D',
    M = 'M',
    Q = 'Q',
    Y = 'Y',
    FQ = 'FQ',
    FY = 'FY',
    LTM = 'LTM',
    NTM = 'NTM',
    YTD = 'YTD',
    FYTD = 'FYTD',
    QTD = 'QTD',
    FQTD = 'FQTD',
}
